/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect, useState } from 'react';

import { configuredClustersStore } from 'stores';
import getClustersWithDocumentHandling from 'App/Pages/Project/IdpApplication/utils/get-clusters-with-document-handling';

/**
 * @param {Object} props - Hook props object
 * @param {string} [props.clusterId] - Cluster id for pre-selected cluster. If not provided then first available cluster with document handling feature is selected
 */
export function useClusterSelection({ clusterId }) {
  const clusters = getClustersWithDocumentHandling(configuredClustersStore.clusters);
  const firstAvailableClusterWithDocumentHandling = clusters?.find((cluster) => !cluster.disabled);
  const preSelectedCluster = clusters?.find((cluster) => cluster.id === clusterId && !cluster.disabled);
  const [selectedCluster, setSelectedCluster] = useState(
    preSelectedCluster ?? firstAvailableClusterWithDocumentHandling
  );

  useEffect(() => {
    const newPreSelectedCluster = clusters?.find((cluster) => cluster.id === clusterId && !cluster.disabled);
    if (newPreSelectedCluster && newPreSelectedCluster.id !== selectedCluster?.id) {
      setSelectedCluster(newPreSelectedCluster);
    }
  }, [clusterId]);

  return {
    clusters,
    selectedCluster,
    setSelectedCluster
  };
}
